export const state = () => ({
    currentHost: "",
})

export const mutations = {
    setCurrentHost: function (state, currentHost) {
        state.currentHost = currentHost;
    },
}

export const getters = {
    isJJ: ({isJJ}) => isJJ,
    currentHost: ({currentHost}) => currentHost
}

